export const blueprintData = [
  {
    label: 'Upload Building Drawings',
    desc: "Clients begin by uploading their building drawings to our platform. Whether it's an AutoCAD file or a PDF, our system accepts a variety of formats for convenience.",
  },
  {
    label: 'CAD Conversion',
    desc: 'Our skilled CAD technicians convert the building drawings into professional CAD files and PDF escape plans.',
  },
  {
    label: 'Client Review and Approval',
    desc: 'Once the escape plans are ready, clients have the opportunity to review and approve them. They can provide feedback or request revisions to ensure the plans meet their specifications.',
  },
  {
    label: 'Printing and Delivery',
    desc: 'After approval, clients can choose to have the escape plans printed and delivered to their preferred address. We offer a range of printing options and materials to suit different needs.',
  },
  {
    label: 'Payment and Completion ',
    desc: 'Finally, clients can make payment securely through our platform. Once the payment is processed, the project is marked as completed, and clients receive their finalized escape plans.',
  },
];
